// extracted by mini-css-extract-plugin
export default {"wrapper":"language-switcher-module--wrapper--96771","item":"language-switcher-module--item--314cf","active":"language-switcher-module--active--f73c3"};